import { render } from "./AppPlaceholder.vue?vue&type=template&id=a6b4b9b0&scoped=true"
import script from "./AppPlaceholder.vue?vue&type=script&lang=js"
export * from "./AppPlaceholder.vue?vue&type=script&lang=js"

import "./AppPlaceholder.vue?vue&type=style&index=0&id=a6b4b9b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6b4b9b0"]])

export default __exports__